module.exports = __webpack_public_path__ + "static/media/6_export.3b6495ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/6_export.jpg
// module id = 320
// module chunks = 0